module.exports = __webpack_public_path__ + "static/img/Oval5.f98597d2.png";